<template>
    <a :href="href" target="_blank" class="msc-tool ba-card">
        <div class="msc-tool-header">
            <builderall-icon :code="icon"></builderall-icon>
            <span class="msc-tool-title">{{ title }}</span>
        </div>
        <span :class="`msc-tool-badge ${badgeClass}`">
            <span :class="`ba-circle ba-sm ${circleClass}`"></span>
            {{ $t(badgeText) }}
        </span>
    </a>
</template>

<script>
export default {
    computed: {
        badgeClass() {
            return {
                'true': 'connected',
                'false': 'disconnected',
                'coming-soon': 'coming-soon',
            }[this.status];
        },
        circleClass() {
            return {
                'true': 'ba-green',
                'false': 'ba-red',
                'coming-soon': 'ba-gray',
            }[this.status];
        },
        badgeText() {
            return {
                'true': 'ct-active',
                'false': 'ct-inactive',
                'coming-soon': 'ct-coming-soon',
            }[this.status];
        },
    },
    props: {
        href: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        status: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.msc-tool {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;

    &::before {
        content: '';
        position: absolute;
        left: -80px;
        top: 48%;
        width: 80px;
        height: 2px;
        background-color: #fff;
    }

    &:hover {
        transition: all 0.3s linear;
        transform: scale(1.03);
        transform-origin: center;
    }

    &:hover:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 16px;
        padding: 2px;
        /* Largura da borda */
        background: linear-gradient(45deg, #0072E1, #003E7B);
        -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        mask-composite: exclude;
        pointer-events: none;
        /* Permite interagir com o conteúdo interno */
    }

    .msc-tool-header {
        display: flex;
        align-items: center;
        gap: 8px;

        .msc-tool-title {
            font-size: 14px;
            font-weight: 600;
            color: #4D5D71;
        }
    }

    .msc-tool-badge {
        font-size: 12px;
        font-weight: 600;
        padding: 2px 8px;
        border-radius: 100px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;

        span {
            display: flex;
        }

        &.connected {
            background-color: #EAF7EE;
            color: #00C38E;
            border: 1px solid #00C38E;
        }

        &.disconnected {
            background-color: #FADDDD;
            color: #FF3636;
            border: 1px solid #FF3636;
        }

        &.coming-soon {
            background: #EEF2F5;
            color: #8E9EB5;
            border: 1px solid #8E9EB5;
            .ba-circle::before {
                background-color: #8E9EB5;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/dashboard/layout/site/MainSiteCardToolStatus.vue